import {
  updateFavoriteTemplate,
  saveProjectTemplate,
  removeTemplate as removeTemplateApi,
  removeVideoTemplate as removeVideoTemplateApi,
  fetchFeaturedTemplates,
} from "../../api/templates";
import { fetchUserTemplateById } from "../../api/user";
import { saveProjectBody } from "../../constants/apiRequestBody";
import { TEMPLATE_LAYOUT } from "../../constants/dashboard";
import { generateProjectId } from "../../constants/general";
import { setIdle, setLoading } from "../../store/common/appStateSlice";

import {
  setFeaturedTemplates,
  setHasMoreHorizontalVidboardTemplates,
  setHasMoreVerticalVidboardTemplates,
  setHorizontalTemplates,
  setHorizontalVidboardTemplates,
  setHorizontalVideoTemplates,
  setTemplateLoading,
  setUserTemplates,
  setVerticalTemplates,
  setVerticalVidboardTemplates,
  setVerticalVideoTemplates,
} from "../../store/templates/templatesSlice";
import { PAGINATION_OFFSET, showToast } from "../../utils/general";
import { getFromLocal } from "../../utils/localStorage";

export const removeTemplate =
  (id, isUserTemplate, isTemplatePopover) => async (dispatch, getState) => {
    try {
      dispatch(setLoading());
      const userId = getFromLocal("userId");
      await removeTemplateApi(userId, id, !isUserTemplate);

      const {
        templates,
        userTemplates,
        activeLayout,
        verticalTemplates,
        horizontalTemplates,
      } = getState().templates;
      const isVerticalLayout = activeLayout === TEMPLATE_LAYOUT.VERTICAL;

      if (isUserTemplate) {
        if (isTemplatePopover) {
          dispatch(setUserTemplates(userTemplates.filter((i) => i.id !== id)));
        } else {
          if (isVerticalLayout) {
            dispatch(
              setVerticalTemplates(verticalTemplates.filter((i) => i.id !== id))
            );
          } else {
            dispatch(
              setHorizontalTemplates(
                horizontalTemplates.filter((i) => i.id !== id)
              )
            );
          }
        }
      } else {
        dispatch(setFeaturedTemplates(templates.filter((i) => i.id !== id)));
      }
      dispatch(setIdle());
      showToast("Successfully deleted");
    } catch (error) {
      showToast("Something went wrong", "", "danger");
      console.log(error);
      dispatch(setIdle());
    }
  };

export const removeVideoTemplate = (id) => async (dispatch, getState) => {
  try {
    dispatch(setLoading());
    const userId = getFromLocal("userId");
    await removeVideoTemplateApi(userId, id);

    const { verticalVideoTemplates, horizontalVideoTemplates, activeLayout } =
      getState().templates;
    const isVerticalLayout = activeLayout === TEMPLATE_LAYOUT.VERTICAL;

    if (isVerticalLayout) {
      dispatch(
        setVerticalVideoTemplates(
          verticalVideoTemplates.filter((i) => i.id !== id)
        )
      );
    } else {
      dispatch(
        setHorizontalVideoTemplates(
          horizontalVideoTemplates.filter((i) => i.id !== id)
        )
      );
    }
    dispatch(setIdle());
    showToast("Successfully deleted");
  } catch (error) {
    showToast("Something went wrong", "", "danger");
    console.log(error);
    dispatch(setIdle());
  }
};

export const updateTemplate =
  (id, isFavorite, isTemplatePopover) => async (dispatch, getState) => {
    try {
      dispatch(setLoading());
      const { activeLayout, ...templateState } = getState().templates;

      const userTemplates = [...(templateState?.userTemplates || [])];
      const verticalTemplates = [...(templateState?.verticalTemplates || [])];
      const horizontalTemplates = [
        ...(templateState?.horizontalTemplates || []),
      ];

      const isVerticalLayout = activeLayout === TEMPLATE_LAYOUT.VERTICAL;

      const userId = getFromLocal("userId");

      await updateFavoriteTemplate(id, userId, isFavorite);
      if (isTemplatePopover) {
        const findTemplateIndex = userTemplates.findIndex(
          (temp) => temp.id === id
        );
        userTemplates.splice(findTemplateIndex, 1, {
          ...userTemplates[findTemplateIndex],
          isFavorite: isFavorite,
        });

        dispatch(setUserTemplates(userTemplates));
      } else {
        if (isVerticalLayout) {
          const findTemplateIndex = verticalTemplates.findIndex(
            (temp) => temp.id === id
          );
          verticalTemplates.splice(findTemplateIndex, 1, {
            ...verticalTemplates[findTemplateIndex],
            isFavorite: isFavorite,
          });

          dispatch(setVerticalTemplates(verticalTemplates));
        } else {
          const findTemplateIndex = horizontalTemplates.findIndex(
            (temp) => temp.id === id
          );
          horizontalTemplates.splice(findTemplateIndex, 1, {
            ...horizontalTemplates[findTemplateIndex],
            isFavorite: isFavorite,
          });

          dispatch(setHorizontalTemplates(horizontalTemplates));
        }
      }

      dispatch(setIdle());
    } catch (error) {
      console.log(error, "error");
      dispatch(setIdle());
    }
  };

export const duplicateTemplate =
  (copyId, navigate, activeLayout, isTheme = false) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading());
      const template = await fetchUserTemplateById(copyId);
      const id = generateProjectId();
      const userId = getFromLocal("userId");
      const projectBody = saveProjectBody({
        ...template,
        templateId: id,
        user: userId,
        category: null,
      });
      const response = await saveProjectTemplate(
        userId,
        {
          ...projectBody,
        },
        false
      );
      const { verticalTemplates, horizontalTemplates, userTemplates } =
        getState().templates;

      if (isTheme) {
        dispatch(setUserTemplates([response, ...userTemplates]));
      } else {
        const updatedTemplates = [
          response,
          ...(activeLayout === TEMPLATE_LAYOUT.VERTICAL
            ? verticalTemplates
            : horizontalTemplates),
        ];
        dispatch(
          activeLayout === TEMPLATE_LAYOUT.VERTICAL
            ? setVerticalTemplates(updatedTemplates)
            : setHorizontalTemplates(updatedTemplates)
        );
      }

      dispatch(setIdle());
      showToast("Successfully duplicated", "", "success");
    } catch (error) {
      dispatch(setIdle());
    }
  };

export const loadVerticalVidboardTemplates =
  (search, page, offset) => async (dispatch, getState) => {
    try {
      const { verticalVidboardTemplates } = getState().templates;
      const existingTemplates = [...(verticalVidboardTemplates || [])];
      dispatch(setTemplateLoading(true));
      const data = await fetchFeaturedTemplates(
        page,
        search,
        offset,
        TEMPLATE_LAYOUT.VERTICAL
      );
      const responseTemplates = [...(data?.data || [])];
      const hasMore =
        // responseTemplates.length !== data.recordsTotal &&
        ((page || 0) + 1) * PAGINATION_OFFSET < data.recordsTotal;
      dispatch(setHasMoreVerticalVidboardTemplates(hasMore));
      const templates =
        page === 0
          ? responseTemplates
          : [...existingTemplates, ...responseTemplates];
      dispatch(setVerticalVidboardTemplates(templates));
      dispatch(setTemplateLoading(false));
    } catch (error) {
      dispatch(setVerticalVidboardTemplates([]));
      console.error("Error loading user templates:", error);
      dispatch(setTemplateLoading(false));
    }
  };
export const loadHorizontalVidboardTemplates =
  (search, page, offset) => async (dispatch, getState) => {
    try {
      const { horizontalVidboardTemplates } = getState().templates;
      const existingTemplates = [...(horizontalVidboardTemplates || [])];
      dispatch(setTemplateLoading(true));
      const data = await fetchFeaturedTemplates(
        page,
        search,
        offset,
        TEMPLATE_LAYOUT.HORIZONTAL
      );
      const responseTemplates = [...(data?.data || [])];
      const hasMore =
        // responseTemplates.length !== data.recordsTotal &&
        ((page || 0) + 1) * PAGINATION_OFFSET < data.recordsTotal;
      dispatch(setHasMoreHorizontalVidboardTemplates(hasMore));
      const templates =
        page === 0
          ? responseTemplates
          : [...existingTemplates, ...responseTemplates];
      dispatch(setHorizontalVidboardTemplates(templates));
      dispatch(setTemplateLoading(false));
    } catch (error) {
      dispatch(setHorizontalVidboardTemplates([]));
      console.error("Error loading user templates:", error);
      dispatch(setTemplateLoading(false));
    }
  };
